var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOtherFont = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.21339 14.1025C6.0669 14.1025 5.94483 14.061 5.84717 13.978C5.7544 13.895 5.70801 13.79 5.70801 13.6631C5.70801 13.5801 5.72999 13.4824 5.77393 13.3701L9.3628 3.80469C9.48487 3.4873 9.69971 3.32861 10.0073 3.32861C10.3003 3.32861 10.5078 3.4873 10.6299 3.80469L14.2261 13.3701C14.27 13.4971 14.292 13.5947 14.292 13.6631C14.292 13.79 14.2432 13.895 14.1455 13.978C14.0527 14.061 13.9331 14.1025 13.7866 14.1025C13.5523 14.1025 13.3862 13.9731 13.2886 13.7144L12.2046 10.7627H7.78809L6.70411 13.7144C6.61622 13.9731 6.45264 14.1025 6.21339 14.1025ZM8.08106 9.89844H11.9116L10.022 4.66895H9.97803L8.08106 9.89844Z",
    fill: "#1B1B1B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3739_8306)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3739_8306)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.2345,
    y: 16,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.297,
    y: 16,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.3595,
    y: 16,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.42188,
    y: 16,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.48438,
    y: 16,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5469,
    y: 16,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.6094,
    y: 16,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.6719,
    y: 16,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.7344,
    y: 16,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.203247,
    y: 17.0312,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.26575,
    y: 17.0312,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.32825,
    y: 17.0312,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.3905,
    y: 17.0312,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.45312,
    y: 17.0312,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5156,
    y: 17.0312,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5781,
    y: 17.0312,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.6406,
    y: 17.0312,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.7031,
    y: 17.0312,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.7656,
    y: 17.0312,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.2345,
    y: 18.0625,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.297,
    y: 18.0625,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.3595,
    y: 18.0625,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.42188,
    y: 18.0625,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.48438,
    y: 18.0625,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5469,
    y: 18.0625,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.6094,
    y: 18.0625,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.6719,
    y: 18.0625,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.7344,
    y: 18.0625,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.203247,
    y: 19.0938,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.26575,
    y: 19.0938,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.32825,
    y: 19.0938,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.3905,
    y: 19.0938,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.45312,
    y: 19.0938,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5156,
    y: 19.0938,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5781,
    y: 19.0938,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.6406,
    y: 19.0938,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.7031,
    y: 19.0938,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.7656,
    y: 19.0938,
    width: 1.03125,
    height: 1.03125,
    fill: "#1B1B1B",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 16,
    width: 18,
    height: 4,
    rx: 1,
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3739_8306"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 16,
    width: 18,
    height: 4,
    rx: 1,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3739_8306"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 16,
    width: 22,
    height: 4.125,
    rx: 1.375,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOtherFont);
export default ForwardRef;